import styled from 'styled-components'

export default styled.div`
  padding: 10px;
  height:100vh;
  width: 90%;
  max-width: 800px;
  margin: 40px auto;
  position: relative;
  font-size: 12px;
  color: #333;
  font-style: sans-serif;

  .title {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .logo-wrapper {
    background: mistyrose;
  }

  .logo {
    height: 60px;
    width: auto;
  }

  .sm-margin {
    margin-bottom: 5px;
  }

  .comment {
    font-style: italic;
  }

  .signature {
    width: auto;
    height: 50px;
  }

  .sm-text {
    font-size: 10px;
  }

  .sig-label {
    font-weight: 600;
  }
`


// WEBPACK FOOTER //
// ./src/Containers/ClaimPdf/styles.js